import React, { Component } from "react";
import axios from 'axios';
import SearchForm from './Gif-components/SearchForm';
import GifList from './Gif-components/GifList';


class GifContent extends Component{

    constructor() {
        super();
        this.state = {
          gifs: []
        };
    } 
    
    componentDidMount() {
        this.performSearch();
    }

    performSearch = (query = 'funny') => {
        axios.get(`http://api.giphy.com/v1/gifs/search?q=${query}&limit=12&api_key=qXLTrqKevpKwMcqOOkvyEX35chipApY1`)
        .then(response => {
            this.setState({
                gifs: response.data.data
            });
        })
        .catch(error => {
            console.log('Error fetching and parsing data', error);
        });
    }

    render(){
        console.log(this.state.gifs);
        return(
            <div className="gif-container">
                <div className="gif-header">
                    <h1 className="gif-title">GifSearch</h1>
                    <SearchForm onSearch={this.performSearch} />
                </div>
                <p className="gifcontent-p">I've created this gif search to make the website a little more fun!</p>
                <div className="gif-content">
                    <GifList data={this.state.gifs} />
                </div>
            </div>
        );
    }
}

export default GifContent;